var modules_3fa78883 = {"container":"Breadcrumb_module_container__acd12244","item":"Breadcrumb_module_item__acd12244"};
import "../../../assets/esm/components/Breadcrumb/src/Breadcrumb~C9Ijsmtn.css";

export { modules_3fa78883 as default };
//# sourceMappingURL=Breadcrumb.module.less.js.map
